(function() {
  'use strict';

  function Search($translate, Utils) {
    var getSearch = function() {
      var search = {
        facetly: {
          facets: [
            {
              id: 'text',
              type: 'search',
              placeholder: $translate.instant('Start typing to search'),
              facetly: true
            },
            {
              id: 'block',
              type: 'select',
              label: $translate.instant('Part'),
              multiselect: true,
              options: [
                { id: 'events', title: $translate.instant('Events') },
                { id: 'goals', title: $translate.instant('Goals') },
                { id: 'users', title: $translate.instant('Users') }
              ],
              facetly: false,
              advanced: true
            }
          ]
        },
        filters: [
          {
            id: 'text',
            matchFunc: function(item, _key, value) {
              return item.doc.name.indexOf(value) !== -1;
            }
          },
          {
            id: 'block',
            matchFunc: function(item, _key, value) {
              if (value.length === 0) {
                return true;
              }
              return value.indexOf(item.doc.block) !== -1;
            }
          }
        ],
        orders: {
          name: function(item) {
            return Utils.safeLowerStr(item.doc.name);
          },
          block: function(item) {
            return item.doc.block;
          }
        },
        orderGroups: {
          name: {
            title: $translate.instant('name'),
            orders: ['block', 'name'],
            groupBy: {
              title: '',
              notitle: $translate.instant('other'),
              getter: function(item) {
                return _.startCase(item.doc.block);
              }
            }
          }
        },
        defaultFilter: {
        },
        defaultOrder: 'name'
      };
      return search;
    };

    var service = {
      search: getSearch()
    };

    return service;
  }

  Search.$inject = ['$translate', 'UtilsService'];

  angular.module('component.emailTemplates')
    .service('EmailTypeSearch', Search);
})();
